import { render, staticRenderFns } from "./MentionUsers.html?vue&type=template&id=8a963f80&scoped=true&"
import script from "./MentionUsers.js?vue&type=script&lang=js&"
export * from "./MentionUsers.js?vue&type=script&lang=js&"
import style0 from "./MentionUsers.scss?vue&type=style&index=0&id=8a963f80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a963f80",
  null
  
)

export default component.exports